<div class="mb-16 flex flex-col">
  <div class="mx-auto mb-6 mt-10 flex w-[90%] items-center justify-between">
    <h1 class="text-3xl">Ventas</h1>
    <button
      (click)="crearVentaEfectivo()"
      class="btn hover:medium-green flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:bg-seasalt hover:text-dark-blue"
    >
      <mat-icon aria-hidden="false" aria-label="icono añadir gasto" fontIcon="add" />
      Crear Venta en Efectivo
    </button>
  </div>
  <ag-grid-angular
    style="min-width: 90%; height: 75vh"
    class="ag-theme-quartz mx-auto"
    [rowData]="ventas"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    (rowDoubleClicked)="onRowDoubleClicked($event)"
  />
</div>
